import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles(theme => ({
	root: {
		'& .logo-icon': {
			width: 48,
			height: 48,
			transition: theme.transitions.create(['width', 'height'], {
				duration: theme.transitions.duration.shortest,
				easing: theme.transitions.easing.easeInOut
			})
		},
		'& .react-badge, & .logo-text': {
			transition: theme.transitions.create('opacity', {
				duration: theme.transitions.duration.shortest,
				easing: theme.transitions.easing.easeInOut
			})
		}
	},
	reactBadge: {
		// backgroundColor: '#121212',
		color: '#009FDF'
	}
}));

function Logo() {
	const classes = useStyles();

	return (
		<div>
			{/*<div className={clsx(classes.root, 'flex items-center')}>*/}
			{/*	<img className="logo-icon" src="assets/images/logos/spl-logo-small.png" alt="logo" />*/}
			{/*	<Typography className="text-16 mx-12 font-light logo-text" color="inherit">*/}
			{/*		*/}
			{/*	</Typography>*/}
			{/*</div>*/}
			<div className={clsx(classes.reactBadge, 'react-badge flex items-center py-4 px-8 rounded')}>
				<img className="logo-icon" width= "170px" src="assets/images/logos/surevue.svg" alt="logo" />
			</div>
		</div>

	);
}

export default Logo;
